module.exports = __webpack_public_path__ + "static/media/v1.9e2bf2d6.mp4";